import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useState, forwardRef, useImperativeHandle, } from 'react';
import { Popover } from '@mui/material';
import Button from '../button/Button';
const PopoverDialog = forwardRef(({ buttonProps, children, anchorOrigin, transformOrigin, }, ref) => {
    const [anchorEl, setAnchorEl] = useState(null);
    const [open, setOpen] = useState(false);
    const handleButtonClick = (event) => {
        setAnchorEl(event.currentTarget);
        setOpen(true);
    };
    const handleClose = () => {
        setOpen(false);
        setAnchorEl(null);
    };
    const id = open ? 'popover-dialog' : undefined;
    useImperativeHandle(ref, () => ({
        open: () => {
            setOpen(true);
        },
        close: () => {
            setOpen(false);
        },
    }));
    return (_jsxs("div", { children: [_jsx(Button, Object.assign({}, buttonProps, { onClick: event => {
                    var _a;
                    handleButtonClick(event);
                    (_a = buttonProps.onClick) === null || _a === void 0 ? void 0 : _a.call(buttonProps, event);
                } })), _jsx(Popover, { id: id, open: open, anchorEl: anchorEl, onClose: handleClose, anchorOrigin: anchorOrigin || {
                    vertical: 'bottom',
                    horizontal: 'center',
                }, transformOrigin: transformOrigin || {
                    vertical: 'top',
                    horizontal: 'center',
                }, children: _jsx("div", { style: { padding: '16px', maxWidth: '300px' }, children: children }) })] }));
});
export default PopoverDialog;
